import type { Key } from '@react-types/shared';
import type { Selection } from './types';

// 检查指定的键是否被选中
export const isKeySelected = (key: Key, selectedKeys?: Selection): boolean => {
    if (!selectedKeys) return false;
    if (selectedKeys === "all") return true;
    return selectedKeys.has(key);
};

// 检查指定的键是否被禁用
export const isKeyDisabled = (key: Key, disabledKeys?: Key[]): boolean => {
    return disabledKeys ? disabledKeys.includes(key) : false;
};